import {useDispatch} from 'react-redux';
import {useCallback} from 'react';
import {QuestionCircleUnfilledIcon} from '~library/svg/QuestionCircleUnfilledIcon';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';

export const OnboardingModalButton = ({visible}) => {
  const dispatch = useDispatch();

  const onClickHandler = useCallback(() => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {forceShowOnboardingModal: true},
    });
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div>
      <button
        className="unstyled-button"
        data-qa-id="onboard-open"
        onClick={onClickHandler}
        type="button"
      >
        <QuestionCircleUnfilledIcon />
      </button>
    </div>
  );
};
